var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo q-mb-xl",class:{
    'logo--square': _vm.square,
    logoSmallPadding: _vm.smallPadding,
    fill: _vm.fill,
    'no-shadow': _vm.flat
  }},[_c('q-icon',{staticClass:"logoIcon",style:(_vm.styles),attrs:{"name":_vm.logoPath}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }